import React from 'react';
import DefaultSpinner from './DefaultSpinner';
import './PlayerJoinLoadingOverlay.scss';

type Props = {
  visible?: boolean;
  text?: string;
};

const PlayerJoinLoadingOverlay = ({ visible = true, text }: Props): JSX.Element | null => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className="player-join-loading-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-test-id="player-join-loading-overlay"
    >
      <DefaultSpinner visible text={text} />
    </div>
  );
};

export default PlayerJoinLoadingOverlay;
